module.exports = __webpack_public_path__ + "static/baci-img-54729ff8c4adc65832e6d37564b3a1c4.jpg";